import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from 'src/app/_services/account.service';

@Component({
  selector: 'app-head-tours',
  templateUrl: './head-tours.component.html',
  styleUrls: ['./head-tours.component.css']
})
export class HeadToursComponent implements OnInit {
  
  constructor(
    private accountService: AccountService,
    private router:Router) { }

  ngOnInit(): void {
  }

  logout(){
    this.accountService.logout();
    this.router.navigate(['home']);
  }

}
